import { createRoute, redirect } from '@tanstack/react-router'
import { store } from 'store/store'
import { z } from 'zod'

import OrderGuestCreateRoute from '../pages/OrderGuestCreatePage'
import { orderGuestRoute } from './OrderGuestRoute'

export const orderGuestCreateRoute = createRoute({
  beforeLoad: async () => {
    const { token } = store.getState().authReducer

    if (token) {
      throw redirect({
        to: '/order/create'
      })
    }
  },
  getParentRoute: () => orderGuestRoute,
  component: () => <OrderGuestCreateRoute />,

  path: '/create',
  validateSearch: (search) =>
    z
      .object({
        data: z.string().optional()
      })
      .parse(search)
})
